import { render, staticRenderFns } from "./shareTip.vue?vue&type=template&id=5e78e4f8&scoped=true&"
import script from "./shareTip.vue?vue&type=script&lang=js&"
export * from "./shareTip.vue?vue&type=script&lang=js&"
import style0 from "./shareTip.vue?vue&type=style&index=0&id=5e78e4f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78e4f8",
  null
  
)

export default component.exports